export const productTypeKeys = {
  all: 'all',
  my: 'my',
  liked: 'liked',
  affiliate: 'affiliate',
};
